import React from 'react';
import { Button, Menu, MenuButton, MenuList, MenuItem } from '@chakra-ui/react';
import { ChevronDownIcon, CheckIcon } from '@chakra-ui/icons';
import { useMutation } from 'react-query';
import { mutateFunction } from '../../libs/apis';
import { CustomToast } from '../toast/CustomToast';

const RSVPMenuDropDown = ({
  status,
  setStatus,
  eventId,
  tabIndex,
  refetchEvents,
  refetchMyEvents,
}) => {
  const { mutate, isLoading: isLoading } = useMutation(mutateFunction);
  const { addToast } = CustomToast();

  const statusMap = {
    Going: 'attending',
    Interested: 'interested',
    'Not interested': 'not_attending',
  };

  const handleChangeStatus = (value) => {
    setStatus(value);
    const status = statusMap[value];

    mutate(
      {
        key: `events/${eventId}/rsvp`,
        method: 'post',
        data: {
          rsvp_type: status,
        },
      },
      {
        onSuccess(res) {
          addToast(res);
          if (tabIndex === 0) {
            refetchEvents();
          } else {
            refetchMyEvents();
          }
        },
      },
    );
  };

  return (
    <>
      <Menu>
        <MenuButton
          as={Button}
          size="sm"
          colorScheme="blue"
          w="full"
          rightIcon={<ChevronDownIcon />}
          mt="auto"
          py={5}
          bg="#134A70"
          color="white"
          _hover={{ bg: '#134A70' }}
        >
          {status || 'Interested?'}
        </MenuButton>
        <MenuList>
          {['Going', 'Interested', 'Not interested'].map((value) => (
            <MenuItem
              key={value}
              onClick={() => handleChangeStatus(value)}
              className="flex items-center gap-2"
            >
              {value}
              {value === status && <CheckIcon mr={2} />}
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </>
  );
};

export default RSVPMenuDropDown;
